import src from "IMAGE";
export default { src, width: 360, height: 360, blurWidth: 0, blurHeight: 0};
